import { Grid, GridColumn } from '@atlaskit/page';
import { inject, observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import Store from '../store';
import BlanketStore, { BlanketBody } from '../store/blanketStore';

import { onDesktop, onMobile } from './mobile/responsive';
import ProductScreen from './Products/ProductScreen';

interface BlanketProps {
  shouldShow: boolean;
}

const BlanketComponent = styled.div`
  position: fixed;
  pointer-events: ${(props: BlanketProps) => (props.shouldShow ? 'all' : 'none')};
  width: 100vw;
  height: 100vh;
  background-color: white;
  left: 0;
  top: 0;
  overflow-y: auto;

  z-index: 4;
  opacity: ${(props: BlanketProps) => (props.shouldShow ? 1 : 0)};
  transition: opacity 0.25s ease-out;
`;

const Body = styled.div`
  ${onDesktop(`
    margin: 40px 0 0 64px;
  `)}

  ${onMobile(`
    margin-top: 60px;
  `)}
`;

interface Props {
  blanketStore: BlanketStore;
}

@observer
class Blanket extends React.Component<Props> {
  componentDidMount() {
    addEventListener('keydown', this.onEscape);
  }

  componentWillUnmount() {
    removeEventListener('keydown', this.onEscape);
  }

  render() {
    const { body } = this.props.blanketStore;

    return (
      <BlanketComponent shouldShow={body !== BlanketBody.None}>
        <Body>
          <Grid theme={{ columns: 16 }}>
            <GridColumn key="blanket-content" medium={16}>
              {body === BlanketBody.Products && <ProductScreen />}
            </GridColumn>
          </Grid>
        </Body>
      </BlanketComponent>
    );
  }

  private onEscape = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.props.blanketStore.hideBlanket();
    }
  };
}

export default inject(({ blanketStore }: Store) => ({
  blanketStore,
}))(Blanket);
